import { z } from 'zod'

/**
 * Wire vocabulary for the scribe quality gate — the issue shape is returned to
 * the FE on the draft-response `verification` field, so this file must stay
 * browser-safe (schema-only `.contract`). Verdict parsing + gate predicates live
 * in the sibling server-only `draft-verification.ts`.
 */

export const VERIFICATION_SEVERITIES = ['high', 'medium', 'low'] as const
export const VERIFICATION_CATEGORIES = [
  'hallucination',
  'omission',
  'coding',
  'consistency',
] as const

export type DraftVerificationSeverity = (typeof VERIFICATION_SEVERITIES)[number]
export type DraftVerificationCategory = (typeof VERIFICATION_CATEGORIES)[number]
export type DraftVerificationOutcome = 'pass' | 'fail' | 'unavailable'

// `description` + `evidence` may quote the transcript → PHI → response-only,
// never the audit event or logs.
export const DraftVerificationIssueSchema = z.object({
  severity: z.enum(VERIFICATION_SEVERITIES),
  category: z.enum(VERIFICATION_CATEGORIES),
  section: z.string(),
  description: z.string(),
  evidence: z.string(),
})
export type DraftVerificationIssue = z.infer<typeof DraftVerificationIssueSchema>
